import type { ReactNode } from 'react';
import { useAppData } from '../data/DataProvider.js';
import { isOnline } from '../platform/capabilities.js';
import { Chip } from './ui.js';

/**
 * Los estados de sincronizacion, en castellano.
 *
 * Se exporta porque los pinta TAMBIEN la pantalla de diagnostico, que hasta el
 * 08/09/2026 enseñaba el nombre interno —«synced»— en una aplicacion que es
 * solo en castellano (§ idioma de UI_UX_SPEC.md). Dos vocabularios para el
 * mismo estado es la forma barata de que uno de los dos envejezca.
 */
export const TEXTO_DE_ESTADO: Record<string, string> = {
  synced: 'Sincronizado',
  pending: 'Cambios pendientes',
  syncing: 'Sincronizando…',
  offline: 'Sin conexión',
  error: 'Error de sincronización',
  conflict: 'Conflicto por revisar',
};

/**
 * Indicador discreto. En estado `synced` no se muestra nada: la app actua en
 * silencio (docs/SYNC_ENGINE.md §7).
 */
export function SyncIndicator(): ReactNode {
  const { status, pending } = useAppData();
  if (status === 'synced') return null;
  // `offline` con red es el arranque —`DataProvider` nace así hasta la primera
  // vuelta—, no una desconexión. Misma regla que `AvisoDeSincronizacion`.
  if (status === 'offline' && isOnline()) return null;

  const tono =
    status === 'error' || status === 'conflict' ? 'error' : status === 'offline' ? 'aviso' : 'neutro';

  return (
    <Chip tono={tono}>
      {TEXTO_DE_ESTADO[status] ?? status}
      {pending > 0 && status !== 'syncing' ? ` · ${pending}` : ''}
    </Chip>
  );
}
